import { render, staticRenderFns } from "./DisciplinaView.vue?vue&type=template&id=619679ee&scoped=true"
import script from "./DisciplinaView.vue?vue&type=script&lang=js"
export * from "./DisciplinaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619679ee",
  null
  
)

export default component.exports